import { FC } from 'react';
import './information.scss';

import { IShopInformation } from 'types';
import { Span } from 'components/helpers';
import ExpandableText from 'components/expandableText/ExpandableText';
import { translations } from 'translations/en';

const MAX_CHARS = 250;

const Information: FC<IShopInformation> = ({ categories, description, isExpended }) => {
  const categoriesText = categories.join(' | ');

  const maxChars = isExpended ? description.length : MAX_CHARS;

  return (
    <div className="section shop-information">
      <Span text={translations.COMMON.ABOUT} className="title" />
      <div className="text-container">
        <Span text={categoriesText} className="categories" />
        <ExpandableText
          text={description}
          maxChars={maxChars}
          isCollapsable={!isExpended}
          isTextClickable={false}
        />
      </div>
    </div>
  );
};

export default Information;
